import { ITimeslot } from "../types/main";
import { t } from "../utils/utils";

export const ticketSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2Zm-2-1.46c-1.19.69-2 1.99-2 3.46s.81 2.77 2 3.46V18H4v-2.54c1.19-.69 2-1.99 2-3.46 0-1.48-.8-2.77-1.99-3.46L4 6h16v2.54ZM11 15h2v2h-2v-2Zm0-4h2v2h-2v-2Zm0-4h2v2h-2V7Z"/></svg>';

export const navigationSteps = [
	{
		title: t.navigationSteps.attraction,
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.1503 14.42C20.3803 13.65 20.5003 12.84 20.5003 12C20.5003 11.16 20.3803 10.35 20.1503 9.58C20.9303 8.98 21.1703 7.88 20.6603 7C20.1503 6.12 19.0803 5.77 18.1703 6.15C17.0603 4.98 15.6103 4.12 13.9903 3.73C13.8503 2.75 13.0103 2 12.0003 2C10.9903 2 10.1503 2.75 10.0203 3.73C8.3903 4.12 6.9503 4.98 5.8303 6.15C4.9203 5.77 3.8503 6.12 3.3403 7C2.8303 7.88 3.0703 8.98 3.8503 9.58C3.6203 10.35 3.5003 11.16 3.5003 12C3.5003 12.84 3.6203 13.65 3.8503 14.42C3.0703 15.02 2.8303 16.12 3.3403 17C3.8503 17.88 4.9203 18.23 5.8303 17.85C6.2303 18.27 6.6603 18.64 7.1303 18.97L5.7803 22H7.6603L8.6403 19.81C9.0803 20 9.5403 20.15 10.0203 20.27C10.1503 21.25 10.9903 22 12.0003 22C13.0103 22 13.8503 21.25 13.9803 20.27C14.4403 20.16 14.8903 20.01 15.3203 19.83L16.3003 22H18.1803L16.8403 19C17.3203 18.66 17.7703 18.28 18.1803 17.85C19.0903 18.23 20.1703 17.88 20.6703 17C21.1703 16.12 20.9303 15.02 20.1503 14.42ZM13.5603 18.75C13.1903 18.29 12.6303 18 12.0003 18C11.3703 18 10.8003 18.29 10.4303 18.75C10.0303 18.66 9.6403 18.54 9.2703 18.38L10.7003 15.19C11.1003 15.35 11.5403 15.44 12.0003 15.44C12.4403 15.44 12.8703 15.36 13.2603 15.21L14.6803 18.39C14.3203 18.54 13.9503 18.66 13.5603 18.75ZM10.4803 12.02C10.4803 11.19 11.1503 10.52 11.9803 10.52C12.8103 10.52 13.4803 11.19 13.4803 12.02C13.4803 12.85 12.8103 13.52 11.9803 13.52C11.1503 13.52 10.4803 12.85 10.4803 12.02ZM18.7103 14.01C18.1003 14.08 17.5303 14.42 17.1903 15C16.8703 15.56 16.8503 16.2 17.0703 16.75C16.7903 17.04 16.4903 17.3 16.1703 17.54L14.6703 14.19C15.1603 13.6 15.4503 12.85 15.4503 12.03C15.4503 10.14 13.9003 8.62 11.9903 8.62C10.0803 8.62 8.5303 10.15 8.5303 12.03C8.5303 12.83 8.8103 13.57 9.2803 14.16L7.7603 17.55C7.4503 17.32 7.1603 17.07 6.8903 16.79C7.1503 16.23 7.1303 15.57 6.8003 15C6.4603 14.41 5.8703 14.06 5.2403 14.01C5.0203 13.33 4.9103 12.61 4.9103 11.86C4.9103 11.22 5.0003 10.6 5.1603 10.01C5.8203 9.98 6.4603 9.63 6.8103 9.01C7.1803 8.38 7.1603 7.63 6.8203 7.03C7.7403 6.05 8.9303 5.34 10.2703 5C10.6103 5.59 11.2603 6 12.0003 6C12.7403 6 13.3903 5.6 13.7303 5C15.0703 5.34 16.2603 6.07 17.1703 7.05C16.8503 7.64 16.8403 8.38 17.2003 9C17.5503 9.6 18.1603 9.95 18.8003 10C18.9603 10.59 19.0503 11.21 19.0503 11.86C19.0503 12.61 18.9303 13.33 18.7103 14.01Z" /></svg>'
	},
	{
		title: t.navigationSteps.pass,
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z" /></svg>'
	},
	{
		title: t.navigationSteps.date,
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z"/></svg>'
	},
	{
		title: t.navigationSteps.summary,
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z"/></svg>'
	},
];

export const editNavigationSteps = [
	{
		title: t.navigationSteps.pass,
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z" /></svg>'
	},
	{
		title: t.navigationSteps.date,
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z"/></svg>'
	},
	{
		title: t.navigationSteps.summary,
		icon: '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z"/></svg>'
	},
];

export const arrivalTimeData: ITimeslot[] = [
	{
		startTime: "12:00 AM",
		capacity: "600",
		available: "598",
		endTime: "12:25 AM"
	},
];

// export const staticAttractions: IGetAttractionAvailability = {
// 	restrictions: 'Gold, Platinum',
// 	availabilities: [
// 		{
// 		"calendarDate": "2022-06-01",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-02",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-03",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-04",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-05",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-06",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-07",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-08",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 		"calendarDate": "2022-06-09",
// 		"isBlockedOut": true,
// 		"blockOutReason": "No available timeslot for the selected attraction",
// 		"cardTypeid": "199,200",
// 		"cardType": "",
// 		"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-10",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-11",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-12",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-13",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-14",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-15",
// 			"isBlockedOut": false,
// 			"blockOutReason": "",
// 			"cardTypeid": "",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-16",
// 			"isBlockedOut": false,
// 			"blockOutReason": "",
// 			"cardTypeid": "",
// 			"cardType": "",
// 			"timeslots": [
// 				{
// 				"startTime": "12:00 AM",
// 				"capacity": "600",
// 				"available": "598",
// 				"endTime": "12:25 AM"
// 				}
// 			]
// 		},
// 		{
// 			"calendarDate": "2022-06-17",
// 			"isBlockedOut": false,
// 			"blockOutReason": "",
// 			"cardTypeid": "",
// 			"cardType": "",
// 			"timeslots": [
// 				{
// 				"startTime": "12:00 AM",
// 				"capacity": "600",
// 				"available": "597",
// 				"endTime": "12:25 AM"
// 				}
// 			]
// 		},
// 		{
// 			"calendarDate": "2022-06-18",
// 			"isBlockedOut": false,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-19",
// 			"isBlockedOut": false,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-20",
// 			"isBlockedOut": false,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-21",
// 			"isBlockedOut": false,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": [
// 				{
// 				"startTime": "12:00 AM",
// 				"capacity": "600",
// 				"available": "597",
// 				"endTime": "12:25 AM"
// 				}
// 			]
// 		},
// 		{
// 			"calendarDate": "2022-06-22",
// 			"isBlockedOut": false,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-23",
// 			"isBlockedOut": false,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-24",
// 			"isBlockedOut": false,
// 			"blockOutReason": "",
// 			"cardTypeid": "199,200,900,901",
// 			"cardType": "",
// 			"timeslots": [
// 				{
// 					"startTime": "12:00",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "12:15"
// 				},
// 				{
// 					"startTime": "12:15",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "12:30"
// 				},
// 				{
// 					"startTime": "12:30",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "12:45"
// 				},
// 				{
// 					"startTime": "13:00",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "13:15"
// 				},
// 				{
// 					"startTime": "13:15",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "13:30"
// 				},
// 				{
// 					"startTime": "13:30",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "13:45"
// 				},
// 				{
// 					"startTime": "13:45",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "14:00"
// 				},
// 				{
// 					"startTime": "14:00",
// 					"capacity": "600",
// 					"available": "597",
// 					"endTime": "14:15"
// 				}
// 			]
// 		},
// 		{
// 			"calendarDate": "2022-06-25",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-26",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-27",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-28",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-29",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		},
// 		{
// 			"calendarDate": "2022-06-30",
// 			"isBlockedOut": true,
// 			"blockOutReason": "No available timeslot for the selected attraction",
// 			"cardTypeid": "199,200",
// 			"cardType": "",
// 			"timeslots": null
// 		}
// 	]
// };